import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  loading_tab_details=false;
  mobile:boolean=false;
  constructor() { }

  ngOnInit(): void {
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split('%')[0];
      if(from=="profiles"){
        (<any>$('.nav-tabs a[href="#border-top-profiles"]')).tab('show');
        this.getTabProfiles();
      } 
      if(from=="show"){
        (<any>$('.nav-tabs a[href="#border-top-users"]')).tab('show');
        this.getTabUsers();
      }
    }
    if (window.screen.width < 768) { // 768px portrait
      this.mobile = true;
    }else {
      this.mobile = false;
    }
  }

  getTabUsers() {}

  getTabProfiles() {}

  getTabRoles() {}

}
